<template>
    <b-card class="address-card mb-3">
        <table class="address_block table custom-stripe">
            <tr>
                <td width="80">{{ uLang('app.address_type') }}:</td>
                <td><b-badge pill variant="primary">{{ address.type.value }}</b-badge></td>
            </tr>
            <tr>
                <td>{{ uLang('app.country') }}:</td>
                <td><b-badge pill variant="primary">{{ address.country.name }}</b-badge></td>
            </tr>
            <tr>
                <td>{{ uLang('app.zipcode') }}:</td>
                <td>{{ address.zipcode }}</td>
            </tr>
            <tr>
                <td>{{ uLang('app.address') }}:</td>
                <td>{{ address.street }} {{ address.house_number }}</td>
            </tr>
            <tr>
                <td>{{ uLang('app.city') }}:</td>
                <td>{{ address.city }}</td>
            </tr>
        </table>
        <div class="action" v-if="!showOnly">
            <a v-if="editAddress && $can('update-relations-addresses')" class="action_icon card-link pointer"
               :title="uLang('app.edit')" @click="editAddress(address)"><i class="fa fa-lg fa-edit"></i></a>
            <a v-if="deleteAddress && $can('delete-relations-addresses')" class="action_icon card-link pointer"
               :title="uLang('app.delete')" @click="deleteAddress(address)"><i class="fa fa-lg fa-trash"></i></a>
            <a v-if="duplicateAddress && $can('create-relations-addresses') " class="action_icon card-link pointer"
               :title="uLang('app.duplicate')" @click="duplicateAddress(address)"><i class="fa fa-lg fa-clone"></i></a>
            <a v-if="!hideMap" class="action_icon card-link float-right map-link"
               :title="uLang('app.show_on_google_maps')" target="_blank" :href="mapLink"><i class="fa fa-lg fa-map"></i></a>
        </div>
    </b-card>
</template>
<script>
    export default {
        props: {
            address: {
                type: Object,
                default: null,
                required: true,
            },
            editAddress: {
                type: Function,
                required: false,
                default: null,
            },
            deleteAddress: {
                type: Function,
                required: false,
                default: null,
            },
            duplicateAddress: {
                type: Function,
                required: false,
                default: null,
            },
            hideMap: {
                type: Boolean,
                default: false,
            },
            showOnly: {
                type: Boolean,
                default: false
            }
        },

        data() {
            return {
                googleMapsUrl: 'https://www.google.com/maps/search/?api=1&query='
            }
        },

        computed: {
            mapLink() {
                return this.googleMapsUrl + this.address.zipcode + ' ' + this.address.street + ' ' + ' ' + this.address.house_number;
            }
        }
    }
</script>
<style lang="scss" scoped>
    table.address_block {
        tr:first-child {
            td {
                border-top: none;
            }
        }
        td {
            padding-left: 0px !important;
        }

    }
    .action_icon {
        color: #5A4587 !important;
    }
    .action_icon:hover {
        color: lighten(#5A4587, 25%) !important;
    }
</style>
